module.exports = __webpack_public_path__ + "34e294645c9cc275ccf4db4ec43d4eec.webp";